// extracted by mini-css-extract-plugin
export default {"Dropdown":"A4rnC","skeleton-progress":"jOy1H"};